<template>
  <div class="grid-container-wrapper">
    <ImagePreview
      :label="imageLabel"
      :value="displayFields.attachments"
      class="grid-full-width"
    />
    <TextInput
      label="番号"
      :value="displayFields.number"
      readOnly
      class="grid-column-start"
    />
    <TextInput
      label="有効期限"
      :value="displayFields.licenseTermYears"
      readOnly
    />
    <DateInput
      label="取得日（最終更新日）"
      :value="displayFields.issueDate"
      readOnly
    />
    <DateInput
      label="次回更新期限"
      :value="displayFields.nextUpdateDate"
      readOnly
      v-if="showNextUpdateDate"
    />
    <LongTextInput
      label="備考"
      :value="displayFields.remarks"
      :rows="4"
      readOnly
      class="grid-column-start grid-full-width"
    />
  </div>
</template>

<script>
import TextInput from "../../components/form/TextInput.vue";
import DateInput from "../../components/form/DateInput.vue";
import LongTextInput from "../../components/form/LongTextInput.vue";
import ImagePreview from "../../components/ImagePreview.vue";

export default {
  name: "OtherPreview",
  components: {
    TextInput,
    DateInput,
    LongTextInput,
    ImagePreview,
  },
  props: {
    viewFields: {
      type: Object,
      default: () => ({}),
    },
    licenseOptions: {
      type: Array,
      default: () => [],
    },
    imageLabel: {
      type: String,
      default: "画像",
    },
  },
  computed: {
    displayFields() {
      const fields = this.viewFields || {};
      return {
        number: fields.number || "-",
        licenseTermYears: fields.licenseTermYears
          ? `${fields.licenseTermYears}年`
          : "-",
        issueDate: fields.issueDate || "-",
        nextUpdateDate: fields.nextUpdateDate || "-",
        remarks: fields.remarks,
        attachments: fields.attachments || [],
      };
    },
    showNextUpdateDate() {
      const termYears = this.viewFields
        ? this.viewFields.licenseTermYears
        : null;
      return termYears !== undefined && termYears !== null && termYears !== "";
    },
    imagePreviewItems() {
      const attachments = this.displayFields.attachments;
      if (Array.isArray(attachments) && attachments.length) {
        return attachments;
      }
      if (this.displayFields.imageUrl) {
        return [
          {
            previewUrl: this.displayFields.imageUrl,
            name:
              this.displayFields.licenseType ||
              this.displayFields.number ||
              "preview",
          },
        ];
      }
      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.grid-container-wrapper {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(240px, 1fr));
  gap: 24px;
  flex-wrap: wrap;
}

.grid-column-start {
  grid-column-start: 1;
}

.grid-full-width {
  grid-column: 1 / -1;
}
</style>
